<template>
    <ColorPalette
        :modelValue="selectedColor"
        :colorsGrid="getExtensionOptionColorsGrid()"
        :tooltip="getExtensionOptionLabel()"
        :icon="getExtensionOptionIcon()"
        :active="active"
        :disabled="disabled"
        :isVisible="showColorPalette"
        @update:isVisible="updateVisibility"
        @update:modelValue="updateHighlight"
        @reset:modelValue="resetHighlight"
    />
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';
import ColorPalette from 'vcomponents/common/Inputs/ColorPalette.vue';

export default {
    components: {
        ColorPalette,
    },
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            showColorPalette: false,
            selectedColor: '',
        };
    },
    computed: {
        active() {
            return this.editor.isActive('highlight');
        },
    },
    methods: {
        getExtensionOptionLabel() {
            return this.$t.__(this.getExtensionOption(this.option).label);
        },
        getExtensionOptionIcon() {
            return this.getExtensionOption(this.option).icon;
        },
        getExtensionOptionColorsGrid() {
            return this.getExtensionOption(this.option).colorsGrid;
        },
        updateHighlight(color) {
            this.selectedColor = color;
            this.editor.chain().focus().toggleHighlight({ color: this.selectedColor }).run();
        },
        resetHighlight() {
            this.selectedColor = '';
            this.editor.chain().focus().unsetHighlight().run();
        },
        updateVisibility(visible) {
            this.selectedColor = '';
            this.showColorPalette = visible;

            if (this.showColorPalette && this.active) {
                this.selectedColor = this.editor.getAttributes('highlight').color;
            }
        },
    },
};
</script>
